module.exports = __webpack_public_path__ + "img/1541922068.b7e1ddd8.jpg";